import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/shared/services/common/common.service';

@Component({
  selector: 'app-store-terms-and-condition',
  templateUrl: './store-terms-and-condition.component.html',
  styleUrls: ['./store-terms-and-condition.component.css']
})
export class StoreTermsAndConditionComponent implements OnInit {
  TermsOfUse: any;
  constructor(private commonService: CommonService) { }
  ngOnInit() {
    this.fn_GetPrivacyPolicy();
  }
  fn_GetPrivacyPolicy() {
    this.commonService.getPrivacyPolicyAndTermsofUse().subscribe((res: any) => {
      if (res.StatusCode === 200) {
        if (res.Data.ResponseData != null) { 
            this.TermsOfUse = res.Data.ResponseData[1];
        }
      }
    }, (err: any) => {
    });
  }


}
